import { createStore } from 'effector';
import { alwaysNew } from '~/shared/lib/alwaysNew';
import { setPayoutNewOrdersCount } from './events';

export const $payoutNewOrdersCount = createStore(0).on(setPayoutNewOrdersCount, alwaysNew);
